import {
  WishlistStreamItem,
  WishlistStreamItem_DeprecatedProduct,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wishlist/v1/page/stream.types';

type Product = {
  streamPosition: number;
  type: {
    $case: 'deprecatedProduct';
    deprecatedProduct: WishlistStreamItem_DeprecatedProduct;
  };
};

export function isProduct(item: WishlistStreamItem): item is Product {
  return item.type?.$case === 'deprecatedProduct';
}
